import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import useGetUser from '../../hooks/useGetUser';
import useIsLogged from '../../hooks/useIsLogged';

function PrivateRoute({ component: Component, ...rest }) {
  const isLogged = useIsLogged();
  const user = useGetUser();
  const history = useHistory();
  useEffect(() => {
    if (!isLogged) {
      history.replace({
        pathname: '/',
        search: `?next=${history.location.pathname}${history.location.search}`,
      });
    }
  }, [isLogged, history]);
  if (!user) return null;
  return (
    <Route
      {...rest}
      render={(props) => (
        <Component {...props} />
      )}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

export default PrivateRoute;
